import React from 'react'
import { connect } from 'react-redux'

import { CircularProgress } from '@material-ui/core'

import CarAvailability from './CarAvailability'
import CarSpecifications from './CarSpecifications'

import './index.scss'

class CarDetails extends React.Component {
    constructor() {
        super()

        this.state = {}
    }

    render() {
        const {
            threadDetailsLoading,
            threadDetails,
            historicalDialogue,
        } = this.props

        const firstMessage = historicalDialogue && historicalDialogue[0]

        return (
            <div className='CarDetails'>
                {threadDetailsLoading && (
                    <div className='loading-wrapper'>
                        <CircularProgress size={30} />
                    </div>
                )}

                {!threadDetailsLoading && threadDetails && (
                    <React.Fragment>
                        <CarAvailability
                            threadDetails={threadDetails}
                            firstMessage={firstMessage}
                        />
                        <CarSpecifications
                            threadDetails={threadDetails}
                            firstMessage={firstMessage}
                        />
                    </React.Fragment>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
    const {
        historicalDialogueLoading,
        historicalDialogue,
    } = state.operatorDashboard
    const {
        threadDetailsLoading,
        threadDetails,
    } = state.operatorDashboardDetails

    return {
        historicalDialogueLoading,
        historicalDialogue,
        threadDetailsLoading,
        threadDetails,
    }
}

export default connect(mapStateToProps, {})(CarDetails)
